import React, { useState } from 'react';
import { UiCard, UiInput, UiGrid, UiText, UiButton } from '../..';
export function UiExampleInput() {
    var _a = useState(''), value = _a[0], setValue = _a[1];
    return (React.createElement(UiCard, { contentPadding: 2 },
        React.createElement(UiGrid, null, [-1, 0, 1, 2].map(function (size) { return (React.createElement(UiGrid, { spacing: 1, key: size },
            React.createElement(UiText, { weight: 2 },
                "Size:",
                size),
            React.createElement(UiInput, { value: value, onChangeValue: setValue, label: "Label", placeholder: "Placeholder", size: size, adornmentStart: React.createElement(UiButton, { size: size }, "Adornment"), adornmentEnd: React.createElement(UiButton, { size: size }, "Adornment") }))); }))));
}
